export default (props, vars) =>
  vars?.isInViewOfferDetailsMode ? '80px' : '0px';
